import axios from 'axios';
import type { AxiosResponse } from 'axios';

import type { ServerData } from '@/@types/base';

import type {
  // ApiOnboardingQuestionsPayload,
  // ApiOnboardingQuestionsResponse,
  ApiSaveAnswerPayload,
} from '@/@types/onboarding';

import { baseQuestions } from '@/data/quiz';

export async function getOnboardingQuestions() {
  return baseQuestions;
}

// export async function getOnboardingQuestions(
//   payload: ApiOnboardingQuestionsPayload
// ) {
//   const response: AxiosResponse<ServerData<ApiOnboardingQuestionsResponse>> =
//     await axios({
//       method: 'GET',
//       url: '/question/list',
//       params: payload,
//     });

//   const {
//     data: { success, data: questions },
//   } = response;

//   if (!success) {
//     throw new Error('api getOnboardingQuestions success false');
//   }

//   return questions;
// }

export async function saveOnboardingAnswer(payload: ApiSaveAnswerPayload) {
  const response: AxiosResponse<ServerData<null>> = await axios({
    method: 'POST',
    url: '/answer/save',
    data: payload,
  });

  const {
    data: { success },
  } = response;

  if (!success) {
    throw new Error('api saveOnboardingAnswer success false');
  }
}
